import { messaging } from '@/lib/firebase/get-firebase-messaging-instance';
import { signOutMutation, useDeleteUserWorkspaceFcmTokenMutation, usesignOutMutation } from '@/types/generated/graphql';
import { COOKIE_KEY } from '@shared/constants';
import { postLogoutAction } from '@shared/utils';
import { notification } from 'antd';
import { deleteToken as deleteFirebaseToken } from 'firebase/messaging';
import Cookies from 'js-cookie';
import { broadcastAuthChange } from './use-auth-state-change';
import { Crisp } from 'crisp-sdk-web';

export function useLogout() {
  const refreshToken = Cookies.get(COOKIE_KEY.refreshToken) ?? '';
  const sessionId = Cookies.get(COOKIE_KEY.sessionId) ?? '';
  const [deleteServerFCM] = useDeleteUserWorkspaceFcmTokenMutation();

  const [signout, { loading }] = usesignOutMutation({
    onCompleted: async (res: signOutMutation) => {
      Crisp.session.reset();
      await deleteServerFCM();
      if (messaging) {
        await deleteFirebaseToken(messaging);
      }
      notification.success({ message: res.signOut?.message });
      broadcastAuthChange();
    },
  });

  async function appLogout() {
    const signoutPromise = signout({
      variables: {
        input: {
          refreshToken,
          sessionId,
        },
      },
    });

    signoutPromise.finally(postLogoutAction);
  }

  return {
    appLogout,
    loading,
  };
}
